var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tippy',{attrs:{"content":_vm.instruction}},[_c('FavouriteHeart',{staticClass:"bg-transparent p-2",attrs:{"favourited":(_vm.favourited || _vm.forceOn) && !_vm.forceOff,"heartClass":_vm.heartClass,"heartSize":_vm.heartSize,"showShadow":true,"showStroke":false},on:{"addFavourite":_vm.runAction,"removeFavourite":_vm.runAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }